<template>

  <div id="searcher">
    <div class="container py-4">
      <div class="row align-items-center">
        <div class="col-12">

          <div class="input-group">
            <label for="search" class="visually-hidden">Search</label>
            <input id="search" @keyup.enter="search()" v-model="inputValue" name="Text" type="text" class="form-control" style="border-color: #6c757d;" placeholder="" aria-label="Search">

            <div class="dropdown">
              <button
                  class="btn btn-dark dropdown-toggle rounded-0"
                  type="button"
                  @click="isDropdownOpen = !isDropdownOpen"
              >
                {{ $t(dropdownOptionSelected) }}
              </button>
              <ul v-if="isDropdownOpen" class="dropdown-menu show" style="display: block; position: absolute; inset: 0px auto auto 0px; transform: translate(0px, 40px);">
                <li><a class="dropdown-item" href="#" @click.prevent="updateTitle('Tots')">{{$t('Tots')}}</a></li>
                <li><a class="dropdown-item" href="#" @click.prevent="updateTitle('Professorat')">{{$t('Professorat')}}</a></li>
                <li><a class="dropdown-item" href="#" @click.prevent="updateTitle('Organització')">{{$t('Organització')}}</a></li>
                <li><a class="dropdown-item" href="#" @click.prevent="updateTitle('Assignatura')">{{$t('Assignatura')}}</a></li>
                <li><a class="dropdown-item" href="#" @click.prevent="updateTitle('Titulació')">{{$t('Titulació')}}</a></li>
                <li><a class="dropdown-item" href="#" @click.prevent="updateTitle('Materials')">{{$t('Materials')}}</a></li>
                <li><a class="dropdown-item" href="#" @click.prevent="updateTitle('Accés Obert')">{{$t('Accés Obert')}}</a></li>
                <li><a class="dropdown-item" href="#" @click.prevent="updateTitle('Treballs Finals')">{{$t('Treballs Finals')}}</a></li>
                <li><a class="dropdown-item" href="#" @click.prevent="updateTitle('Vídeos')">{{$t('Vídeos')}}</a></li>
              </ul>
            </div>


            <button class="btn btn-primary button-action btn-size-40" aria-label="Search" @click='search()'>
              <i class="fas fa-search"></i>
            </button>

            <button class="btn btn-default button-action btn-size-40 rounded-0" @click="isInfoModalOpen = true" aria-label="Más información">
              <i class="fas fa-info"></i>
            </button>

          </div>

        </div>
      </div>
    </div>

    <!-- Modal manually controlled by Vue to avoid Bootstrap JS errors -->
    <div v-if="isInfoModalOpen" class="modal fade show d-block" id="infoModalSearch" tabindex="-1" aria-labelledby="infoModalLabel" style="background: rgba(0,0,0,0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="infoModalLabel">{{ $t('info') }}</h5>
            <button type="button" class="btn-close" @click="isInfoModalOpen = false" aria-label="Close"></button>
          </div>
          <div class="modal-body pre-line">
            {{ $t(`info-modal-search`) }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="isInfoModalOpen = false">OK</button>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>

<script>

import {computed, ref} from "vue";
import router from "@/router";
import {useStore} from "vuex";

export default {
  name: "SearcherSection",

  props: {
    initialOption: {
      type: String,
      default: 'Tots',
    },
  },
  setup(){

    const store = useStore();
    const dropdownOptionSelected = computed(() => store.getters.searchSelected);
    const inputValue = ref("");
    const isDropdownOpen = ref(false);
    const isInfoModalOpen = ref(false);

    const updateTitle = (option) => {
      store.dispatch('updateSearchSelected', option);
      isDropdownOpen.value = false;
    };

    const search = () => {
      if(inputValue.value !== ""){
        if(dropdownOptionSelected.value === "Tots") {
          //router.push({name: 'cercar', query: {q: inputValue.value}});
          navigateWithReplace('cercar', {}, { q: inputValue.value });

        }else if(dropdownOptionSelected.value === "Professorat") {
          navigateWithReplace('professorat', { page: 1, sort: 'professor_nom_sort asc' }, { professor_cerca: inputValue.value });

        }else if(dropdownOptionSelected.value === "Organització") {
          navigateWithReplace('organitzacions', { page: 1, sort: 'organitzacio_nom_ca asc' }, { organitzacio_cerca: inputValue.value });

        }else if(dropdownOptionSelected.value === "Assignatura") {
          navigateWithReplace('assignatures', { page: 1, sort: 'assignatura_sigles asc' }, { assignatura_cerca: inputValue.value });

        }else if(dropdownOptionSelected.value === "Titulació") {
          navigateWithReplace('titulacions', { page: 1, sort: 'titulacio_sigles asc' }, { titulacio_cerca: inputValue.value });

        }else if(dropdownOptionSelected.value === "Materials") {
          navigateWithReplace('materials', { page: 1, sort: 'data desc, activitat_data_available desc' }, { activitat_cerca: inputValue.value });

        }else if(dropdownOptionSelected.value === "Accés Obert") {
          navigateWithReplace('accesObert', { page: 1, sort: 'data desc, activitat_data_available desc' }, { activitat_rights:"Open Access", activitat_cerca: inputValue.value });

        }else if(dropdownOptionSelected.value === "Treballs Finals") {
          navigateWithReplace('treballsFinals', { page: 1, sort: 'data desc, activitat_data_available desc' }, { activitat_comunitat:"pfc", activitat_cerca: inputValue.value });

        }else if(dropdownOptionSelected.value === "Vídeos") {
          navigateWithReplace('videos', { page: 1, sort: 'data desc, activitat_data_available desc' }, { activitat_comunitat:"videodocent", activitat_cerca: inputValue.value });
        }
      }
    };


    const navigateWithReplace = (routeName, params = {}, query = {}) => {
      router.replace({ name: 'dummy-route' }) // Navega a una ruta ficticia
          .then(() => {
            router.push({
              name: routeName,
              params: params,
              query: query
            });
          });
    };


    return{
      dropdownOptionSelected,
      inputValue,
      isDropdownOpen,
      isInfoModalOpen,
      updateTitle,
      search
    }

  }
}

</script>

<style scoped>

#searcher {
  background-color: #d4d5cf;

  form {
    padding: 20px 0;
    width: 100%;

    label {
      display: flex;
      align-items: flex-end;
    }

    .button-action {
      width: 42px;
      border-radius: 0
    }
  }

  .dropdown-item:focus, .dropdown-item:hover {
    background-color: rgb(128, 128, 128);
  }
  a:hover {
    color: #007BC1;
    text-decoration: none;
  }
}

</style>
